<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">จัดการเอกสาร E-TAX</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> จัดการเอกสาร E-TAX
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <!-- search list order -->
          <v-col :cols="IpadProSize ? 9 : MobileSize || IpadSize ? 12 : 6" :class="!IpadProSize && !IpadSize && !MobileSize ? 'pl-0 mb-3 pt-6' : 'mb-3 pt-8'" v-if="disableTable === false">
            <v-text-field v-model="search" placeholder="ค้นหารหัสการสั่งซื้อที่ถูกลบ" outlined dense hide-details>
              <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
            </v-text-field>
          </v-col>
          <!-- count list order -->
          <v-col cols="12" class="pt-3" v-if="disableTable === false">
            <v-row dense>
              <v-col cols="12" class="pt-2">
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">รายการสั่งซื้อสินค้าที่ถูกลบทั้งหมด {{ showCountOrder }} รายการ</span>
              </v-col>
            </v-row>
          </v-col>
          <!-- table list order -->
          <v-col cols="12" v-if="disableTable === false" class="mt-5">
            <v-data-table
            :headers="shop === 'Sale Order' ? headersSaleOrder : headers"
            :items="deleteOrderList"
            :search="search"
            :page.sync="page"
            @pagination="countOrder"
            no-results-text="ไม่พบรายการเอกสาร E-TAX"
            no-data-text="ไม่มีรายการเอกสาร E-TAXในตาราง"
            :footer-props="{'items-per-page-text':'จำนวนแถว'}"
            @update:items-per-page="itemsPerPage"
            :items-per-page="10"
            :class="shop === 'Sale Order' ? 'order-list-table' : 'order-list-table-gracz'"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                {{ formatDateTH(item.created_at) }}
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status === 'export'">
                  <v-chip small color="#ECF8EA" text-color="#1AB759">ดึงข้อมูลแล้ว</v-chip>
                </span>
                <span v-else-if="item.status === 'not_export'">
                  <v-chip small color="#FCF0DA" text-color="#FAAD14">รอการดึงข้อมูล</v-chip>
                </span>
              </template>
              <template v-slot:[`item.net_price`]="{ item }">
                {{ Number(item.net_price).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
              <template v-slot:[`item.transaction_status`]="{ item }">
                <v-chip small :color="getColor(item.transaction_status)" :text-color="getTextColor(item.transaction_status)">
                  {{ getStatus(item.transaction_status) }}
                </v-chip>
              </template>
              <template v-slot:[`item.manages`]="{ item }">
                <v-row>
                  <v-col>
                    <v-btn text rounded color="#27AB9C" :class="!MobileSize? 'px-2' : 'pa-0 ma-0'" small @click="deleteOrderDetail(item)">
                      <v-icon small>mdi-file-document-outline</v-icon>
                      <span>รายละเอียด</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
          <!-- empty data -->
          <v-col cols="12" v-else>
            <v-row justify="center" align-content="center">
              <v-col cols="12" md="12" align="center">
                <div class="my-5">
                  <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
                </div>
                <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายการเอกสาร E-TAX</b></h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
export default {
  components: {
  //   OrderSummary: () => import('@/components/Gracz/Sales/Cart/Card/OrderSummary.vue')
  },
  data () {
    return {
      userDetailSelling: '',
      shop: ''
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push({ path: '/Order/ManageDocumentEtaxMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/ManageDocumentEtax' }).catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    },
    headers () {
      const headers = [
        {
          title: 'รายละเอียดสินค้า',
          dataIndex: 'productdetails',
          key: 'productdetails',
          scopedSlots: { customRender: 'productdetails' },
          width: '50%'
        },
        {
          title: 'จำนวน',
          dataIndex: 'quantity',
          key: 'quantity',
          scopedSlots: { customRender: 'quantity' },
          align: 'center',
          width: '20%'
        },
        {
          title: 'ราคารวม',
          dataIndex: 'net_price',
          scopedSlots: { customRender: 'net_price' },
          key: 'net_price',
          align: 'center',
          width: '20%'
        }
      ]
      return headers
    }
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      this.checkShop()
      this.getListDocumentEtax()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/DeletedOrderListMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/DeletedOrderList' }).catch(() => {})
      }
    },
    async getListDocumentEtax () {
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id
      }
      await this.$store.dispatch('actionsListDocumentEtax', data)
      var response = await this.$store.state.ModuleSaleOrderEtax.stateListDocumentEtax
      console.log('response etax', response)
    },
    checkShop () {
      if (this.userDetailSelling.is_gracz === 'yes') {
        this.shop = 'Gracz'
      } else {
        if (this.userDetailSelling.is_rattana === 'yes') {
          this.shop = 'Rattana'
        } else {
          this.shop = 'Sale Order'
        }
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'User not found in shop.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Order not found.') {
        return ['ไม่พบรายการสั่งซื้อ', 'warning']
      } else if (msg === 'Deleter not found in shop.') {
        return ['ไม่พบผู้ลบรายการสั่งซื้อในร้าน', 'warning']
      } else if (msg === 'user not found.') {
        return ['ไม่พบข้อมูลผู้ลบรายการสั่งซื้อ', 'warning']
      } else {
        return [msg, 'error']
      }
    }
  }
}
</script>
<style lang="css" scoped>
</style>
